import React from "react";
import PropTypes from "prop-types";
import { fetchData } from "../Service/graphQlService";
import { GET_BUYER_DD_QUERY, GET_CONTACT_INVESTOR_BY_ID, GET_INVESTOR_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import debounce from "lodash/debounce";
import Dropdown from "../Dropdown/DropdownForInvestor";
const cloneDeep = require("lodash.clonedeep");

class SelectInvester extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            isBusy: false,
        };
        this.handleSearch = this.handleSearch.bind(this); 
        this.debouncedSearch = debounce(this.performSearch.bind(this), 500);
    }

    // componentDidMount() {
    //     this.loadInitialData();
    // }

    async loadInitialData () {
        this.setState({ isBusy: true });
        const res = await fetchData(GET_BUYER_DD_QUERY, {
            type: "Investor",
            pageOptions: { page: 1, pageSize: 500 },
            sortOptions: [
                { field: "first_name", order: "asc" },
                { field: "last_name", order: "asc" },
                { field: "company_name", order: "asc" },
            ],
        });
        const data = res && res.data && res.data.getContacts && res.data.getContacts.data && res.data.getContacts.data.filter((item) => {
            return (item.first_name || item.last_name || item.company_name) && (item.first_name || item.last_name || item.company_name).trim();
        }) || [];
        this.setState({ items: data, isBusy: false });
    };

    componentDidMount() {
        this.loadInitialData().then(() => {
            this.ensureSelectedInvestorExists();
        });
    }
    
    async ensureSelectedInvestorExists() {
        const { value, valueKey } = this.props;
        const { items } = this.state;
    
        // If there's no selected value, nothing to do
        if (!value) return;
    
        const isPresent = items.some(item => item["contact_id"] === this.props.data.buyer_id);
        if (!isPresent) {
            const res = await fetchData(GET_CONTACT_INVESTOR_BY_ID, { contactid: Number(this.props.data.buyer_id) });
            const extraRecord = res && res.data.getContactByContactid.success && res.data.getContactByContactid.contact;
            if (extraRecord) {
                this.setState(prev => ({
                    items: [...prev.items, extraRecord]
                }));
            }
        }
    }
    

    handleSearch(text) {
        this.debouncedSearch(text);
    };


    async performSearch (text) {
        if (!text) {
            this.loadInitialData(); // Reset
            return;
        }

        // this.setState({ isBusy: true });
        const res = await fetchData(GET_INVESTOR_LIST_QUERY, { type: "Investor", filters: [{first_name: text}] });
        const data = res && res.data && res.data.getContacts && res.data.getContacts.data && res.data.getContacts.data.filter((item) => {
            return (item.first_name || item.last_name || item.company_name) && (item.first_name || item.last_name || item.company_name).trim();
        }) || [];
        this.setState({ items: data, isBusy: false });
    };

    componentWillReceiveProps(nextProps) {
         if (this.props.newBuyer !== nextProps.newBuyer) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newBuyer);
            this.setState({items});
        }
    }

    render() {
        const { items, isBusy } = this.state;
        const {
            theme,
            value,
            valueKey,
            label,
            disabled,
            data,
            withAddNew,
            handleParentChange,
            addNewItem,
            deleted,
            viewMode,
            ...rest
        } = this.props;
        return (
            <div style={{ position: "relative" }}>
                {isBusy && (
                    <div style={{ position: "absolute", top: 0, right: 0, padding: "4px", color: "#666" }}>
                        Loading ...
                    </div>
                )}
                <Dropdown
                    theme={theme}
                    optionsType="seller"
                    optionKey="contact_id"
                    options={items}
                    value={value ? value: ''}
                    valueKey={valueKey}
                    label={label}
                    disabled={!items || disabled}
                    data={data}
                    withAddNew={withAddNew}
                    handleParentChange={handleParentChange}
                    addNewItem={addNewItem}
                    deleted={deleted}
                    viewMode={viewMode}
                    onSearchInput={this.handleSearch} // ✨ Hook search handler
                    newBuyerValue={this.props.newBuyer}
                    {...rest}
                />
            </div>
        );
    }
}

SelectInvester.propTypes = {
    theme: PropTypes.oneOf(["default", "white", "dark"]),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
};

export default SelectInvester;
